module.exports = __webpack_public_path__ + "static/TANMEMORIES-Italic-bbff2cdbc9cdacd5ec42e0f766c73646.woff2";